// Styles
import './hero-banner.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeroBanner = (context) => {
    context?.querySelectorAll('.hero-banner__block').forEach((blockEl) => {
        if (blockEl.dataset.href) {
            blockEl.addEventListener('click', () => {
                location.href = blockEl.dataset.href;
            })
        }
    })
}

if (document.readyState != "loading") {
    [].forEach.call(document.querySelectorAll('.hero-banner__container'), (el) => {
        window.dAgency.initHeroBanner(el);
    });
} else {
    document.addEventListener('DOMContentLoaded', () => {
        [].forEach.call(document.querySelectorAll('.hero-banner__container'), (el) => {
            window.dAgency.initHeroBanner(el);
        });
    });
}